$(document).ready(function () {
    // Render third option for add to next box
    renderThirdOptions();

    $(document).on('change', 'input[name="purchaseOptionCustom"]', function () {
        const selectedOption = $(this).val();

        // const rechargWidget = document.querySelector('recharge-subscription-widget').shadowRoot

        // Check if the checkbox is checked
        if (selectedOption == 'addtonextbox') {
            unCheckRadio();
            $('rc-radio-icon-custom svg circle').show();
            $('.rc-purchase-option-custom').css('border-color', 'var(--rc-widget-brand-color)');
            $('.add-to-cart').hide();
            $('#unloggedAR').show();

            const intervalId = setInterval(() => {
                const purchaseOption = document.querySelector('recharge-subscription-widget').purchaseOption
                if (purchaseOption === 'subscription' || purchaseOption === 'onetime') {
                    $('.add-to-cart').show();
                    $('#unloggedAR').hide();
                    clearInterval(intervalId);
                    $('rc-radio-icon-custom svg circle').hide();
                    $('input[name="purchaseOptionCustom"]').prop('checked', false);
                }
            }, 50);
        }
    })

    document.addEventListener('custom:Widget:Refreshed', function () {
        renderThirdOptions();
    })
});

const unCheckRadio = () => {
    document.querySelector('recharge-subscription-widget')
        .shadowRoot
        .querySelectorAll('rc-radio-icon')
        .forEach((i) => {
            const circle = i.shadowRoot.querySelector('svg circle');
            if (circle) {
                circle.style.display = 'none'
            }

            i.removeAttribute('checked');
        });
    document.querySelector('recharge-subscription-widget')
        .shadowRoot
        .querySelectorAll('.rc-purchase-option')
        .forEach((i) => {
            // i.querySelector('input[name="purchaseOption"]').checked = false;
            // i.removeAttribute('rc-selected');
            // i.removeAttribute('rc-not-selected');
            // const suContainer = i.querySelector('.rc-purchase-option__sub-container');
            // if (suContainer) {
            //     suContainer.remove();
            // }
        });
    document.querySelector('recharge-subscription-widget').purchaseOption = ''


}

const renderThirdOptions = () => {
    // / Delay the execution by 500 milliseconds
    setTimeout(function () {
        const memberPrice = $(".unit-price__price.member-price").attr(
            "data-member-price"
        );
        const regularPrice = $(".price__current_custom").attr("data-price");

        let price = memberPrice || regularPrice;
        var $block = $(".recharge_onetime_addon_box");

        if ($block.length) {
            var label = $block.data("label") || "Add To Next Box";
            // Append the HTML content to elements with class .rc-template__radio
            $block.append(`
                <div class="rc-purchase-option-custom rc-selection__onetime-custom" rc-not-selected="" style="border: 1px solid color-mix(in srgb, #121212 50%, #ffffff);;border-radius: 8px;position: relative;margin-top: 16px;">
                <label class="rc-purchase-option__label-custom" style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start;cursor: pointer;padding: 12px 20px 8px;">
                <div class="rc-purchase-option__selector-custom" style="font-size: 20px;padding: 0px 0px;font-weight: 600;display: flex;align-items: center;">
                    <rc-radio-icon-custom class="rc-purchase-option__checked-indicator-custom" style="margin-right: 8px;">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="rc-unchecked-icon-custom">
                        <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="none"></rect>
                        <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="color-mix(in srgb, #121212 50%, #ffffff)"></rect>
                        <circle cx="12" cy="12" r="6" fill="#121212" style="display:none"></circle>
                        </svg>
                    </rc-radio-icon-custom>
                    <input type="radio" name="purchaseOptionCustom" value="addtonextbox" class="rc-purchase-option__input-custom" style="clip: rect(0px, 0px, 0px, 0px);border-width: 0px;height: 1px;margin: -1px;overflow: hidden;padding: 0px;position: absolute;white-space: nowrap;width: 1px;">
                    Add To Next Box
                </div>
                <div class="rc-purchase-option__prices-custom" style="margin-left: 32px;">
                    <span class="rc-price-custom" style="font-weight: 600;line-height: 1em;font-size:16px">${price ? price : ''}</span>
                </div>
                </label>
            </div>  
          `);
        }

        addPriceToButton(price)

    }, 1000);

}

const addPriceToButton = (price) => {
    const interval = setInterval(async () => {
        if (window.sessionRecharge) {
            clearInterval(interval);
            console.log(window.sessionRecharge)
            const subscriptionsResponse =
                await recharge.subscription.listSubscriptions(sessionRecharge, {
                    limit: 25,
                    sort_by: "id-asc",
                });

            const clubSubscription = subscriptionsResponse?.subscriptions?.find(
                (subscription) =>
                    subscription.external_product_id.ecommerce ===
                    "6804589314099"
            );

            if (clubSubscription && clubSubscription.id) {
                const shadowRoot = document.querySelector(
                    "recharge-subscription-widget"
                ).shadowRoot;
                if (shadowRoot) {
                    const priceElement = shadowRoot.querySelector(
                        ".rc-selection__onetime .rc-price"
                    );

                    if (priceElement) {
                        priceElement.innerHTML = price;
                    } else {
                        console.log("Price element not found in shadow DOM");
                    }
                }
            }
        }
    }, 100);
}